import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { paymentType, paymentMethod } from '@ourbranch/lookups';

import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';
import { StripeCustomerIdField } from '../stripe-customer-id-field';
import { useNormalizePaymentMethod } from '../hooks/use-normalize-payment-method';
import useStyles from '../billing-details-form.styles';
import { SecondaryPaymentMethod } from '../secondary-payment-method';

const firstInstallmentMethodOptions = [
  { id: paymentMethod.CreditCard, value: 'Credit Card' },
  { id: paymentMethod.ACH, value: 'Bank Withdrawal' }
];

const Direct = () => {
  const classes = useStyles();
  const { viewOnly } = useSession();
  const { values } = useFormikContext();

  const showInvoiceNotification = [paymentType.QuarterTerm, paymentType.HalfTerm].includes(values.paymentType);

  useNormalizePaymentMethod(paymentMethod.Direct);

  return (
    <>
      <Grid container className={classes.billingDetailsContainer} spacing={4}>
        <StripeCustomerIdField />
      </Grid>
      <Grid container justifyContent="flex-start" className={classes.billingDetailsContainer} spacing={4}>
        {showInvoiceNotification && (
          <Grid className={classes.directBillingDescription}>
            An invoice will be sent 15 days earlier than the billing day in order to pay it before it's due.
          </Grid>
        )}
        <Grid item xs={4}>
          {/*
            Read-only on the post-bind policy settings page. The field controls
            which method is charged for installment #1 at bind, so once the
            policy is bound the field is historical — toggling it would desync
            the firstInstallmentOnly CC fee schedule (computed in
            computeTransactionFee from this value at bind time) from the
            charges that have already happened. Staff who need to change the
            saved card / bank account use the SecondaryPaymentMethod block
            below; the first-installment method itself is locked.
          */}
          <FormField
            name="directBillPreferredPaymentMethod"
            label="First charge payment method"
            type="select"
            mode="dark"
            options={firstInstallmentMethodOptions}
            permissions={{ isLicensedAction: false }}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          {!viewOnly && <SecondaryPaymentMethod />}
        </Grid>
      </Grid>
    </>
  );
};

export default observer(Direct);
